module.exports = __webpack_public_path__ + "static/media/alpine-landscape-mountain-bonsai.d42b1320.svg";